import Swal from "sweetalert2"

type ErrorAlertProps = {
  message?: string
  html?: string
}

export const ErrorAlert = ({ message, html }: ErrorAlertProps) => {
  return (
    Swal.fire({
      title: "Erro",
      text: message,
      html: html,
      icon: "error",      
    })
  )
}

